import area from '@/area'

export default {
  state: {
    id: '',
    avatar: '',
    mobile: '',
    nickname: '',
    realName: '',
    imAccount: '',
    imUsersig: ''
  },

  mutations: {
    setUserInfo (state, userInfo) {
      state.id = userInfo.id
      state.avatar = userInfo.head
      state.mobile = userInfo.mobile
      state.nickname = userInfo.nickName
      state.realName = userInfo.realName
      state.imAccount = userInfo.imAccount
      state.imUsersig = userInfo.imUsersig
    }
  },

  actions: {
    initUser ({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    }
  }
}